// extracted by mini-css-extract-plugin
export var growableInput = "_9j-0";
export var tagContainer = "_9j-2";
export var textInput = "_9j-1";